import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobSearchComponent } from './job-search.component';

const routes: Routes = [
  { path: '', component: JobSearchComponent, data: { title: 'Search Result', reuseRoute: false } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobSearchRoutingModule {}

@NgModule({
  imports: [
    JobSearchRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [JobSearchComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobSearchModule {}
